<template>
	<div class="col">
		<div>
			<b-form-datepicker size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1"
				class="mb-1" today-button close-button locale="zh" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' }"></b-form-datepicker>
		</div>
		<div v-if="stocks.length">
			<div v-bind:key="data.index" v-for="(data) in stocks.slice(0,12)">
				<b-list-group>
					<div class="mb-1">
						<PlateTextItem :plate_name="data.plate_name" :plate_code="data.plate_code" :c_num="data.c_num"
							:selected="data.plate_code === selectedPlateCode"
							@click="handlePlateClicked(data.plate_code, data.plate_name)"></PlateTextItem>
					</div>
				</b-list-group>
			</div>
		</div>
		<div v-else>
			<span>loading...</span>
		</div>
	</div>
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	import PlateTextItem from 'components/plate/PlateTextItem.vue'
	export default {
		props: {
			date1: String,
			selectedPlateCode: String,
			plate_type: {
				type: Number,
				default: 15,
			},
		},
		data() {
			return {
				stocks: []
			};
		},
		components: {
			PlateTextItem,
			// Navbar
		},
		mounted() {
			// this.refresh_popular();
		},
		methods: {
			handlePlateClicked(plateCode, plateName) {
				this.$emit('plate-selected', plateCode, plateName)	
			},
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			onDatePicked() {
				// console.log(ctx.selectedYMD);
				this.refresh_popular();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			refresh_popular() {
				request_zzquant({
						// url: 'stock/d/popular/' + this.date1
						url: '/market/plates/' + this.plate_type + '/rank/popular?date1=' + this.date1 + '&top_n=12'
						// url: '/market/plates/15/rank?date1=' + this.date1 + '&limit=20'

					})
					.then(res1 => {
						// console.log(res1['data']['data']);
						this.stocks = res1['data']['data'];
					})
					.catch(err => {
						console.log(err);
					});
			},
			p_show_kline(symbol_code) {
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline', symbol_code)
			}
		}
	};
</script>

<style>

</style>